import { X } from "lucide-react"
import { useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import { ProjectContext } from "../App"
import { getReadablePrimaryButtonStyle } from "../utils/buttonColor"

export default function FirstTimeLoginForm(
  { onClose, changePassword, setModalState }:
    {
      onClose: () => void,
      changePassword: (username: string, password: string) => void,
      setModalState: (modalState: 'login' | 'changePassword') => void
    }
) {
  const { project } = useContext(ProjectContext)
  const { t } = useTranslation('auth')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col overflow-y-auto bg-transparent p-5 md:justify-center">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-2"></div>
        <h2 className="text-2xl font-bold">{t('firstTimeLoginTitle')}</h2>
        <div>
          <X className="w-6 h-6 cursor-pointer" onClick={onClose} />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center mt-5">
        <input
          type="text"
          placeholder={t('phoneNumber')}
          className="w-full p-2 rounded-md border border-gray-300"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder={t('password')}
          className="w-full p-2 rounded-md border border-gray-300 mt-2"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          type="button"
          className="mt-5 rounded-md px-4 py-2 font-medium"
          style={getReadablePrimaryButtonStyle(project?.buttonColor)}
          onClick={() => changePassword(username, password)}
        >{t('changePassword')}</button>
        <button
          className="text-gray-500 text-sm mt-2 bg-transparent border-0 p-0 cursor-pointer hover:underline"
          onClick={() => setModalState('login')}
        >{t('backToLogin')}</button>
      </div>
    </div>
  )
}
